import React from 'react';
import Icon from '../../../components/AppIcon';

const ExecutiveSummary = ({ summaryData }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-warning';
    return 'text-error';
  };

  const getScoreBgColor = (score) => {
    if (score >= 80) return 'bg-success/10';
    if (score >= 60) return 'bg-warning/10';
    return 'bg-error/10';
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="FileCheck" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">Ringkasan Eksekutif</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className={`p-4 rounded-lg ${getScoreBgColor(summaryData?.overallScore)}`}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Skor Keseluruhan</span>
            <Icon name="TrendingUp" size={16} color="var(--color-muted-foreground)" />
          </div>
          <div className={`text-3xl font-bold ${getScoreColor(summaryData?.overallScore)} data-text`}>
            {summaryData?.overallScore}
          </div>
          <div className="text-xs text-muted-foreground mt-1">dari 100</div>
        </div>

        <div className={`p-4 rounded-lg ${getScoreBgColor(summaryData?.supplyScore)}`}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Rantai Pasokan</span>
            <Icon name="Truck" size={16} color="var(--color-muted-foreground)" />
          </div>
          <div className={`text-3xl font-bold ${getScoreColor(summaryData?.supplyScore)} data-text`}>
            {summaryData?.supplyScore}
          </div>
          <div className="text-xs text-muted-foreground mt-1">dari 100</div>
        </div>

        <div className={`p-4 rounded-lg ${getScoreBgColor(summaryData?.operationalScore)}`}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Operasional</span>
            <Icon name="Settings" size={16} color="var(--color-muted-foreground)" />
          </div>
          <div className={`text-3xl font-bold ${getScoreColor(summaryData?.operationalScore)} data-text`}>
            {summaryData?.operationalScore}
          </div>
          <div className="text-xs text-muted-foreground mt-1">dari 100</div>
        </div>

        <div className={`p-4 rounded-lg ${getScoreBgColor(summaryData?.financialScore)}`}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Keuangan</span>
            <Icon name="DollarSign" size={16} color="var(--color-muted-foreground)" />
          </div>
          <div className={`text-3xl font-bold ${getScoreColor(summaryData?.financialScore)} data-text`}>
            {summaryData?.financialScore}
          </div>
          <div className="text-xs text-muted-foreground mt-1">dari 100</div>
        </div>
      </div>
      <div className="space-y-4">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-3">Temuan Kunci</h3>
          <div className="space-y-2">
            {summaryData?.keyFindings?.map((finding, index) => (
              <div key={index} className="flex items-start gap-3 p-3 rounded-lg bg-muted/50">
                <Icon 
                  name={finding?.type === 'positive' ? 'CheckCircle2' : finding?.type === 'warning' ? 'AlertTriangle' : 'XCircle'} 
                  size={20} 
                  color={finding?.type === 'positive' ? 'var(--color-success)' : finding?.type === 'warning' ? 'var(--color-warning)' : 'var(--color-error)'} 
                  className="flex-shrink-0 mt-0.5"
                />
                <p className="text-sm text-foreground">{finding?.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-3">Rekomendasi Utama</h3>
          <div className="p-4 rounded-lg bg-primary/5 border border-primary/20">
            <p className="text-sm md:text-base text-foreground leading-relaxed">
              {summaryData?.mainRecommendation}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveSummary;